// @flow

import totalFormatter from './total.formatter';
import rowActionFormatter from './rowAction.formatter';
import type { FormatterArgs } from '../../../types';

const formatters = (args?: FormatterArgs): Array<any> =>
  [totalFormatter, rowActionFormatter].map(formatter => formatter(args));

export default formatters;
